<template>
  <div class="document-downloads-page">
    <h1>{{ toLocal("downloads.check_leaf") }}</h1>
    <p>{{ toLocal("downloads.choose_language_hint") }}</p>
    <label for="document-language">{{ toLocal("downloads.document_language") }}</label>
    <select id="document-language" v-model="selectedLanguage" aria-describedby="document-language-hint">
      <option disabled value="">{{ toLocal("downloads.select_language") }}</option>
      <option v-for="language in languages" :key="language.code" :value="language.code">
        {{ language.name }}
      </option>
    </select>
    <p id="document-language-hint">{{ toLocal("downloads.document_availability") }}</p>
    <div aria-live="polite">
      <p v-if="selectedLanguage && !filteredDocuments.length" class="empty-documents">
        {{ toLocal("downloads.no_documents") }}
      </p>
      <ul v-if="filteredDocuments.length">
        <li v-for="document in filteredDocuments" :key="document.path">
          <a :href="document.path" download>
            {{ toLocal(document.title) }} ({{ selectedLanguageName }}, {{ document.path.endsWith('.pdf') ? 'PDF' : 'DOCX' }})
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import documents from "@/assets/data/document_downloads.json";

export default {
  name: "DocumentDownloadsPage",
  data() {
    return {
      selectedLanguage: "",
      documents,
      languages: [
        { code: "DE", name: "Deutsch" },
        { code: "EN", name: "English" },
        { code: "CZ", name: "Čeština" },
        { code: "NL", name: "Nederlands" },
        { code: "LV", name: "Latviešu" },
        { code: "HU", name: "Magyar" },
        { code: "FR", name: "Français" },
        { code: "IT", name: "Italiano" },
        { code: "ES", name: "Español" },
        { code: "LT", name: "Lietuvių" },
        { code: "MT", name: "Malti" },
        { code: "EE", name: "Eesti" },
      ],
    };
  },
  computed: {
    filteredDocuments() {
      return this.documents.filter(document => document.language === this.selectedLanguage);
    },
    selectedLanguageName() {
      return this.languages.find(language => language.code === this.selectedLanguage)?.name || "";
    },
  },
  metaInfo() {
    return { title: this.toLocal("downloads.check_leaf") };
  },
};
</script>

<style scoped>
.document-downloads-page { max-width: 1000px; margin: 0 auto; padding: 150px 24px 64px; color: #483a5b; }
h1 { font-size: 36px; margin-bottom: 24px; }
p { margin: 24px 0; }
label { display: block; margin-bottom: 12px; font-weight: 600; }
select { padding: 12px; max-width: 100%; font: inherit; border: 1px solid #1e1826; }
li { margin: 20px 0; }
a { color: #b55047; text-decoration: underline; }
</style>
